import { createIcon } from "@chakra-ui/icons";

// Created from compass.svg

export const CompassIcon = createIcon({
  displayName: "Compass",
  viewBox: "0 0 16 40",
  path: (
    <g>
      <path
        d="M8 0.999999L15 20L8 16L1 20L8 0.999999Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 20L8 39L15 20M1 20L7.50386 23.7165C7.8113 23.8922 8.18871 23.8922 8.49614 23.7165L15 20M1 20L7.50386 16.2835C7.81129 16.1078 8.18871 16.1078 8.49614 16.2835L15 20M1 20L8 0.999999L15 20"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
